import type {DrawingAchievementTool} from '../shared/achievements';

/** A completed positive action must change a visible pixel, not merely metadata,
 * hidden RGB bytes, a transparent source, or a navigation/eraser gesture. */
export function hasAuthoredWallChange(before: Uint8ClampedArray, after: Uint8ClampedArray, erasing = false): boolean {
  if (erasing || before.length !== after.length) return false;
  for (let i = 0; i < after.length; i += 4) {
    if (after[i + 3] > 0 && (before[i] !== after[i] || before[i+1] !== after[i+1] || before[i+2] !== after[i+2] || before[i+3] !== after[i+3])) return true;
  }
  return false;
}

/** Eraser usage requires removal, including fully clearing a painted pixel. */
export function hasErasedPaint(before:Uint8ClampedArray,after:Uint8ClampedArray):boolean {
  if(before.length!==after.length)return false;
  for(let i=3;i<before.length;i+=4)if(before[i]>after[i])return true;
  return false;
}

/** Called only after a completed stroke; selection, restores and source insertion
 * have no drawing-tool meaning. Shape gestures retain their own tool identity. */
export function completedDrawingTool(before:Uint8ClampedArray,after:Uint8ClampedArray,brush:Exclude<DrawingAchievementTool,'shapes'>,shape=false):DrawingAchievementTool|null {
  const tool=shape?'shapes':brush;
  return (tool==='eraser'?hasErasedPaint(before,after):hasAuthoredWallChange(before,after))?tool:null;
}
